<template>

    <ion-content class="block__login-forget">
      <section class="block__login-wrapper d-flex justify-content-center align-items-center">
        <b-overlay 
            :show="show"
            rounded="sm"
            spinner-variant="primary"
            spinner-type="grow"
            spinner-small        
        >
          
          <b-card class="text-center">
            <b-img :src="content.src" class="logo" fluid alt="logo"></b-img>
            <p class="title">Réinitialisation du mot de passe</p>
            <form @submit.prevent="submit()">
              <div class="text-left">

                <b-form  @submit.stop.prevent>
                  <label for="feedback-user">Email</label>
                  <b-input type="email" v-model="userId" id="password-user" :class="{error:emailError}"></b-input>
                </b-form>
              </div>
              <Stack></Stack>
              <div class="d-flex flex-column justify-content-center align-items-center flex-nowrap">
                <b-button v-on:click="sendEmail()" class="bt bt__connected" :disabled="notActivated" >{{content.bt_forgeted}}</b-button>
                <b-button v-on:click="goBack()" class="bt bt__forget">{{content.bt_cancel}}</b-button>
              </div>

            </form>
          </b-card>
        </b-overlay>
      </section>


        <b-toast id="error-message" solid toaster="b-toaster-top-full" auto-hide-delay="8000" variant="danger">
          <template v-slot:toast-title>
            <strong class="mr-auto">{{content.error}}</strong>
          </template>
          {{error_desc}}
        </b-toast>

    </ion-content>


</template>


<script>
// import AreasStore from '../AreasStore'
import { mapGetters } from 'vuex'
import utils from '../Utils'
import Stack from '../module/stack/Stack'
import ApiService from '../../services/ApiService'


export default {

  // store:AreasStore,
    components:{
      Stack
    }, 
  data() {
    return {
      content:null,
      notActivated:true,
      error_desc: '',
      show: false,
      userId:null,
      emailError:false,
    };
  },
    computed: {
    ...mapGetters([
      'getLogin',
    ])
  },
  created (){
    this.content = this.getLogin;
  },
  methods : {
    sendEmail(){
      let url = window.location.href.replace('password', 'reset-password');
      ApiService.getProfilApi().forgotPassword(this.userId, url).then(() => {
        this.makeToast('success');
      });
    },
    makeToast(variant = null) {
      if(variant === 'success'){
        this.$bvToast.toast('Un lien pour réinitialiser votre mot de passe vous a été envoyé par mail', {
          title: `Réinitialisation du mot de passe`,
          variant: variant,
          solid: true,
          toaster:'b-toaster-top-center'
        })
      } else {
        this.$bvToast.toast('Une erreur est survenu, email invalide.', {
          title: `Réinitialisation du mot de passe`,
          variant: variant,
          solid: true,
          toaster:'b-toaster-top-center'
        })
      }
    },
    checkMail(){
      if(!utils.validEmail(this.userId)){
          this.emailError = true;
          return true;
        }else{
          this.emailError = false;
          this.activeFormButton();
          return false;
        }
    },
    goBack(){
      this.$router.push({name: "login"});
    },
    activeFormButton(){
      utils.validEmail(this.userId) ? this.notActivated = false : this.notActivated = true;
    },    
  },
  watch:{
    'userId' : function(){
      this.checkMail();
    },
  },  

};
</script>
